export default __webpack_public_path__ + "static/security_onion-ba945afb55fa1826577acf5d99dd8324.png";